/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserDtoFromJSON, UserDtoToJSON, } from './UserDto.js';
import { DefaultMessageDtoFromJSON, DefaultMessageDtoToJSON, } from './DefaultMessageDto.js';
import { ConnectionStatusFromJSON, ConnectionStatusToJSON, } from './ConnectionStatus.js';
import { HomerunConnectionConfigFromJSON, HomerunConnectionConfigToJSON, } from './HomerunConnectionConfig.js';
import { IntegrationTypeFromJSON, IntegrationTypeToJSON, } from './IntegrationType.js';
/**
 * Check if a given object implements the GetAtsIntegrationConnectionResultHomerunConnectionConfig interface.
 */
export function instanceOfGetAtsIntegrationConnectionResultHomerunConnectionConfig(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('createdByEmployer' in value) || value['createdByEmployer'] === undefined)
        return false;
    if (!('sendAsEmployer' in value) || value['sendAsEmployer'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
export function GetAtsIntegrationConnectionResultHomerunConnectionConfigFromJSON(json) {
    return GetAtsIntegrationConnectionResultHomerunConnectionConfigFromJSONTyped(json, false);
}
export function GetAtsIntegrationConnectionResultHomerunConnectionConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': IntegrationTypeFromJSON(json['type']),
        'status': ConnectionStatusFromJSON(json['status']),
        'config': json['config'] == null ? undefined : HomerunConnectionConfigFromJSON(json['config']),
        'defaultMessageDto': json['defaultMessageDto'] == null ? undefined : DefaultMessageDtoFromJSON(json['defaultMessageDto']),
        'createdByEmployer': UserDtoFromJSON(json['createdByEmployer']),
        'sendAsEmployer': UserDtoFromJSON(json['sendAsEmployer']),
        'createdAt': (new Date(json['createdAt'])),
        'lastSyncAt': json['lastSyncAt'] == null ? undefined : (new Date(json['lastSyncAt'])),
    };
}
export function GetAtsIntegrationConnectionResultHomerunConnectionConfigToJSON(json) {
    return GetAtsIntegrationConnectionResultHomerunConnectionConfigToJSONTyped(json, false);
}
export function GetAtsIntegrationConnectionResultHomerunConnectionConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': IntegrationTypeToJSON(value['type']),
        'status': ConnectionStatusToJSON(value['status']),
        'config': HomerunConnectionConfigToJSON(value['config']),
        'defaultMessageDto': DefaultMessageDtoToJSON(value['defaultMessageDto']),
        'createdByEmployer': UserDtoToJSON(value['createdByEmployer']),
        'sendAsEmployer': UserDtoToJSON(value['sendAsEmployer']),
        'createdAt': ((value['createdAt']).toISOString()),
        'lastSyncAt': value['lastSyncAt'] === null ? null : (value['lastSyncAt']?.toISOString()),
    };
}
